module.exports = __webpack_public_path__ + "img/integra.8ea013f3.png";